import { fireGTMEvent } from "@/functions/fireGTMEvent";
import { EXPERIMENT_EVENTS } from "@/settings";
import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { Oval } from "react-loading-icons";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { NavLink } from "react-router-dom";

import * as privateApi from "../../api/privateApi";
import * as publicApi from "../../api/publicApi";
import {
  addAlert,
  setMessage,
  showModal,
} from "../../redux/message/messageSlice";
import { AppDispatch } from "../../redux/store";
import { User, fetchUser, usedFeature } from "../../redux/user/userSlice";

const ConfirmLogin = () => {
  const search = useLocation().search;
  const urlParams = new URLSearchParams(search);
  const confirmationToken = urlParams.get("token");
  const squadId = urlParams.get("squad_id");
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const {
          priceId,
          discountId,
          is_new_user: isNewUser,
        } = await publicApi.confirmLogin(confirmationToken);
        const resUser = await dispatch(fetchUser({ didLogin: true }));
        const user = resUser.payload as User;

        if (priceId) {
          if (user.subscription === "free") {
            privateApi.createCheckoutSession({
              priceId,
              discountId,
              freeTrial: 0,
            });
          } else {
            dispatch(
              setMessage({
                content: "You already have a premium membership! ✅",
              }),
            );
            navigate("/profile");
          }
        } else if (squadId) {
          navigate(`/squad-builder/?saved_squad_id=${squadId}`);
        } else if (isNewUser && !squadId) {
          dispatch(showModal({ modalType: "welcome" }));
          dispatch(usedFeature({ feature: "SHOWN_WELCOME_POPUP" }));
          navigate("/");
        } else {
          dispatch(
            addAlert({
              title: "Login Successful",
              description: "You have successfully logged in!",
              type: "success",
            }),
          );
          navigate("/");
        }
      } catch {
        setError(true);
        ReactGA.event({
          category: "Login",
          action: "email_login_error",
        });
      }
    };

    fetchData();
  }, [confirmationToken, dispatch, navigate, squadId]);

  return error ? (
    <div className="flex flex-col items-center w-full mobile:mt-16 text-white gap-y-8 mt-8 px-4 mobile:px-0">
      <h1 className="my-auto mobile:h-[76px] h-[60px] mobile:text-3xl text-2xl">
        Your link has expired 🚨
      </h1>
      <NavLink
        to={"/login"}
        className="text-lg text-transparent bg-clip-text bg-linear-to-r from-primary-washed-blue to-primary-blue"
      >
        Log in again
      </NavLink>
      <div className="flex flex-col items-center w-full mt-16 mb-16 text-xs font-light text-gray-300">
        <img src={"/full_logo.svg"} className="w-48 mx-auto mb-4" alt="logo" />
        <div className="w-4/5 mobile:w-auto text-center mobile:text-left">
          <span>By logging in you accept our </span>
          <a href={"/tos"} className="text-primary-blue">
            Terms of Service
          </a>
          <span> and </span>
          <a href={"/privacy"} className="text-primary-blue">
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  ) : (
    <div className="flex flex-col w-full">
      <div className="mx-auto mt-4">
        <Oval width="60" height="60" fill="#0396FF" />
      </div>
    </div>
  );
};

export default ConfirmLogin;
